module.exports = __webpack_public_path__ + "img/unitedkingdom-fw.520038c.png";